import dictionary from 'config/dictionary';
import React from 'react';
import styles from './segments.module.scss';

const ConfirmationBody = () => {
  return (
    <>
      <div className={styles.confirmationBody}>
        {dictionary.segments.confirmation.copy}
        <strong>{dictionary.segments.confirmation.warning}</strong>
      </div>
    </>
  );
};

export default ConfirmationBody;
